/**
 * Hero Component Interactions
 * Handles smooth scroll for hero CTA buttons
 * Vanilla JavaScript (no Vue dependencies)
 */

export function initHero() {
  // Smooth scroll for CTA buttons with data-scroll-to attribute
  const scrollLinks = document.querySelectorAll('[data-scroll-to]');

  scrollLinks.forEach(link => {
    link.addEventListener('click', (e) => {
      const targetSelector = e.currentTarget.dataset.scrollTo;

      // Check if it's an anchor link (starts with #)
      if (targetSelector && targetSelector.startsWith('#')) {
        const targetElement = document.querySelector(targetSelector);

        if (targetElement) {
          e.preventDefault();
          targetElement.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      }
      // Otherwise, let the link navigate normally
    });
  });
}

// Auto-initialize on DOM ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initHero);
} else {
  initHero();
}
